import algoliaSearch from "algoliasearch";
import { createBrowserLocalStorageCache } from "@algolia/cache-browser-local-storage";
import { createFallbackableCache } from '@algolia/cache-common';
import { createInMemoryCache } from '@algolia/cache-in-memory';

export let index                 = () => {
    if (typeof algolia_index_name === 'string') {
        return algolia_index_name;
    }

    if (process.env.NODE_ENV === 'development') {
        console.warn('algolia_index_name does not seem valid!', algolia_index_name);
    }

    return null;
};
export let querySuggestionsIndex = () => {
    if (typeof algolia_query_suggestions_index_name === 'string') {
        return algolia_query_suggestions_index_name;
    }

    if (process.env.NODE_ENV === 'development') {
        console.warn('algolia_query_suggestions_index_name does not seem valid!', algolia_query_suggestions_index_name);
    }

    return null;
};

export let algoliaAppId = () => {
    if (typeof algolia_app_id !== 'undefined') {
        return algolia_app_id;
    }

    return null;
};

export let algoliaKeySearch = () => {
    if (typeof algolia_key_search !== 'undefined') {
        return algolia_key_search;
    }

    return null;
};

/**
 * Algolia client with TTL cache (Items expire after 1 month)
 *
 * @return {null|SearchClient}
 */
export const algoliaClient = () => {
    if (!algoliaAppId &&
        !algoliaKeySearch) {
        return null;
    }

    return algoliaSearch(
        algoliaAppId(),
        algoliaKeySearch(),
        {
            responsesCache: createBrowserLocalStorageCache({ key: `responses-cache`, timeToLive: 60 * 60 * 24 * 30 })
        }
    );
};

/**
 * Algolia client with TTL cache (Items expire at 00:00)
 *
 * @return {null|SearchClient}
 */
export const algoliaClientShortTTL                    = () => {
    if (!algoliaAppId &&
        !algoliaKeySearch) {
        return null;
    }

    const midnightTimestamp = new Date();
    midnightTimestamp.setHours(24);
    midnightTimestamp.setMinutes(0);
    midnightTimestamp.setSeconds(0);
    midnightTimestamp.setMilliseconds(0);

    const secondsUntilMidnight = (midnightTimestamp.getTime() - new Date().getTime()) / 1000;

    return algoliaSearch(
        algoliaAppId(),
        algoliaKeySearch(),
        {
            responsesCache: createFallbackableCache({
                caches: [
                    createBrowserLocalStorageCache({ key: `responses-cache-short`, timeToLive: secondsUntilMidnight }),
                    createInMemoryCache(),
                ],
            })
        }
    );
};
export const deleteOldAlgoliaBrowserLocalStorageCache = () => {
    window.localStorage.removeItem(`algoliasearch-client-js-brekz-responses-cache`);
    window.localStorage.removeItem(`brekz-algoliasearch-client-js-brekz-responses-cache`);
    window.localStorage.removeItem(`brekz-algoliasearch-client-js-brekz-responses-cache-short`);
};

export const getAlgoliaInsightsToken = (idCustomer) => {
    return `authenticated-${idCustomer}`;
};

export const getAlgoliaInsightsAnonymousToken = () => {
    const anonymousTokenKey = `algoliasearch-insights-anonymous-token`;
    let anonymousToken      = window.localStorage.getItem(anonymousTokenKey);

    if (anonymousToken) {
        return anonymousToken;
    }

    anonymousToken = `anonymous-${new Date().getTime()}`;

    window.localStorage.setItem(anonymousTokenKey, anonymousToken);

    return anonymousToken;
};
